import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import * as workerTimers from "worker-timers";
import "./timer.css";
import Authapi from "../../Services/Authapi";
import config from "../../../Config";
import swal from 'sweetalert';
import PremiumButton from "../../Layouts/PremiumButton";
import { toast } from 'react-toastify';

const ATTENDANCE_TIMER_ACTIVE_KEY = "attendanceTimerActive";
const AUTO_TIMER_OFF_REASON_KEY = "autoTimerOffReason";
const AUTO_TIMER_OFF_REASON_USER_KEY = "autoTimerOffReasonUserId";
const AUTO_TIMER_OFF_LOGIN_RESET_KEY = "autoTimerOffLoginResetUserId";
const AUTO_TIMER_OFF_MINUTES_KEY = "autoTimerOffMinutes";
const AUTO_TIMER_OFF_NOTIFICATION_KEY = "autoTimerOffNotificationEvent";
const AUTO_TIMER_OFF_REMINDER_STATE_KEY = "autoTimerOffReminderState";
const AUTO_TIMER_OFF_REMINDER_LAST_SHOWN_KEY = "autoTimerOffReminderLastShownAt";
const AUTO_TIMER_OFF_REMINDER_INTERVAL_MS = 60000;
const AUTO_TIMER_OFF_WATCH_INTERVAL_MS = 5000;
const AUTO_TIMER_OFF_TOAST_ID = "auto-timer-off-toast";
const WINDOWS_HELPER_BASE_URL = "http://127.0.0.1:47321";
const WINDOWS_HELPER_SYNC_INTERVAL_MS = 5000;
const AUTO_TIMER_OFF_EXEMPT_REASONS = ["in_meeting"];

class Timer extends Component {
  constructor(props) {

    super(props);
    this.state = {
      timer: 0,
      totaltimer: 0,
      isActive: false,
      isPaused: false,
      startTime: 0,
      stopTime: 0,
      isLoading: false,
      isInitialLoading: true,
      autoTimerOffMinutes: null,
      autoTimerOffReason: "at_work",
      autoTimerOffDefaultReason: "at_work",
    };
    this.countRef = React.createRef(null);
    this.totalCountRef = React.createRef(null);
    this.lastActivityAt = Date.now();
    this.lastAutoTimerOffNotificationAt = null;
    this.autoTimerOffReminderInterval = null;
    this.windowsHelperConnected = false;
    this.windowsHelperEventSeenAt = null;
    this.helperAutoRefreshQueued = false;
    this.activityEvents = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];
    this.helperAttentionSyncInFlight = false;
  }

  async componentDidMount() {
    // console.log(this.props.user.Notification_Status);
    //     if (this.props.user.Notification_Status === 1) {
    //       setInterval(() => {
    //         this.breaktimeremainder()
    //       }, 300000)  // 5 minit 
    //     }

    // Check duration and auth status independently to ensure no blocking
    // Check duration first and wait for it to complete to establish 'isActive' state
    await this.checkDuration();
    await this.fetchAutoTimerOffSettings();
    this.registerActivityListeners();
    this.registerAutoTimerSettingsListener();
    this.registerAutoTimerNotificationListener();
    await this.syncWindowsHelperState();
    await this.syncWindowsHelperEvent();
    this.startWindowsHelperSync();
    this.registerWindowsHelperAttentionListeners();
    this.syncAutoTimerOffReminderLoop();
    this.startAutoTimerWatcher();
    this.setupBreakNotification();
    this.checkTotalTimer();

    this.taskDeadlineInterval = setInterval(async () => {
      try {
        await Authapi.notifyTasksDeadlinePassed();
      } catch (error) {
        console.error("Error notifying task deadlines:", error);
      }
    }, 120000); // 120000 milliseconds = 2 minutes

    window.addEventListener("beforeunload", this.handleComponentUnmount.bind(this));
  }

  checkDuration = async () => {
    try {
      let timeCount = await Authapi.durTime(this.props.user.id);
      const totalDurationInSec = parseInt(timeCount.totalDurationInSec, 10);

      if (totalDurationInSec > 0) {
        this.clearAutoTimerOffReminder();
        this.setState({ timer: totalDurationInSec, isActive: true, isInitialLoading: false }, () => {
          this.setAttendanceTimerActiveFlag(true);
          this.runCycle();
        });
      } else {
        this.setAttendanceTimerActiveFlag(false);
        this.setState({ isInitialLoading: false });
      }
    } catch (error) {
      console.error("Error fetching duration time:", error);
      this.setAttendanceTimerActiveFlag(false);
      this.setState({ isInitialLoading: false });
    }
  }

  setupBreakNotification = async () => {
    try {
      const authResponse = await Authapi.checkAuth(this.props.user.id);
      if (authResponse && authResponse.data && authResponse.data.user && authResponse.data.user.Break_notification_status === 1) {
        // Clear any existing interval just in case
        if (this.breakTimerInterval) clearInterval(this.breakTimerInterval);

        this.breakTimerInterval = setInterval(() => {
          this.breaktimeremainder();
        }, 300000);  // Check every 5 minutes
        this.breaktimeremainder();
      }
    } catch (error) {
      console.error("Error checking auth status:", error);
    }
  }

  async componentDidUpdate(prevProps) {
    const previousUserId = prevProps.user?.id ? String(prevProps.user.id) : "";
    const currentUserId = this.props.user?.id ? String(this.props.user.id) : "";

    if (previousUserId !== currentUserId) {
      this.stopAutoTimerOffReminderLoop();
      window.localStorage.setItem(AUTO_TIMER_OFF_REASON_KEY, "at_work");
      if (currentUserId) {
        window.localStorage.setItem(AUTO_TIMER_OFF_REASON_USER_KEY, currentUserId);
      } else {
        window.localStorage.removeItem(AUTO_TIMER_OFF_REASON_USER_KEY);
      }
      this.setState({ autoTimerOffReason: "at_work" });
      await this.fetchAutoTimerOffSettings();
      await this.syncWindowsHelperState();
      this.syncAutoTimerOffReminderLoop();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleComponentUnmount.bind(this));
    workerTimers.clearInterval(this.countRef.current);
    workerTimers.clearInterval(this.totalCountRef.current);
    clearInterval(this.taskDeadlineInterval);
    clearInterval(this.breakTimerInterval);
    workerTimers.clearInterval(this.autoTimerWatcherInterval);
    workerTimers.clearInterval(this.autoTimerOffReminderInterval);
    workerTimers.clearInterval(this.windowsHelperSyncInterval);
    this.removeActivityListeners();
    this.removeAutoTimerSettingsListener();
    this.removeAutoTimerNotificationListener();
    this.removeWindowsHelperAttentionListeners();
  }

  handleComponentUnmount() {
    if (this.state.isActive) {
      Authapi.saveTime(this.state.timer);
    }
  }

  async checkTotalTimer() {
    try {
      let timeCount = await Authapi.dureTime1(this.props.user.id);

      const totalDurationInSec = parseInt(timeCount.totalDurationInSec, 10);

      if (totalDurationInSec > 0) {
        this.setState({ totaltimer: totalDurationInSec }, this.runCycle1);
      } else {
        // this.setState({ isInitialLoading: false });
      }
    } catch (error) {
      console.error("Error fetching duration time:", error);
      // this.setState({ isInitialLoading: false });
    }
  }

  setAttendanceTimerActiveFlag = (isActive) => {
    window.localStorage.setItem(ATTENDANCE_TIMER_ACTIVE_KEY, isActive ? "true" : "false");
  };

  updateLastActivity = () => {
    this.lastActivityAt = Date.now();
  };

  registerActivityListeners = () => {
    this.activityEvents.forEach((eventName) => {
      document.addEventListener(eventName, this.updateLastActivity, true);
    });
  };

  removeActivityListeners = () => {
    this.activityEvents.forEach((eventName) => {
      document.removeEventListener(eventName, this.updateLastActivity, true);
    });
  };

  fetchAutoTimerOffSettings = async () => {
    try {
      const currentUserId = this.props.user?.id;
      const currentUserKey = currentUserId ? String(currentUserId) : "";
      const loginResetUserId = window.localStorage.getItem(AUTO_TIMER_OFF_LOGIN_RESET_KEY);

      if (!currentUserKey) {
        window.localStorage.setItem(AUTO_TIMER_OFF_REASON_KEY, "at_work");
        window.localStorage.removeItem(AUTO_TIMER_OFF_REASON_USER_KEY);
        this.setState({
          autoTimerOffReason: "at_work",
          autoTimerOffDefaultReason: "at_work",
        });
        return;
      }

      const storedReasonUserId = window.localStorage.getItem(AUTO_TIMER_OFF_REASON_USER_KEY);
      if (storedReasonUserId !== currentUserKey) {
        window.localStorage.setItem(AUTO_TIMER_OFF_REASON_KEY, "at_work");
        window.localStorage.setItem(AUTO_TIMER_OFF_REASON_USER_KEY, currentUserKey);
        this.setState({ autoTimerOffReason: "at_work" });
      }

      if (loginResetUserId === currentUserKey) {
        window.localStorage.setItem(AUTO_TIMER_OFF_REASON_KEY, "at_work");
        window.localStorage.setItem(AUTO_TIMER_OFF_REASON_USER_KEY, currentUserKey);
        this.setState({ autoTimerOffReason: "at_work", autoTimerOffDefaultReason: "at_work" });
        return;
      }

      const response = await Authapi.getAutoTimerOffReason();
      if (response && response.status && response.data) {
        const configuredMinutes = response.data.auto_timer_off_minutes || null;
        const activeReason =
          storedReasonUserId === currentUserKey
            ? window.localStorage.getItem(AUTO_TIMER_OFF_REASON_KEY) || "at_work"
            : "at_work";

        window.localStorage.setItem(
          AUTO_TIMER_OFF_MINUTES_KEY,
          configuredMinutes !== null ? String(configuredMinutes) : ""
        );
        window.localStorage.setItem(AUTO_TIMER_OFF_REASON_KEY, activeReason);
        window.localStorage.setItem(AUTO_TIMER_OFF_REASON_USER_KEY, currentUserKey);
        this.setState({
          autoTimerOffMinutes: configuredMinutes,
          autoTimerOffReason: activeReason,
          autoTimerOffDefaultReason: response.data.configured_default_reason || response.data.default_reason || "at_work",
        });
      }
    } catch (error) {
      console.error("Error fetching auto timer off settings:", error);
    }
  };

  handleAutoTimerSettingsUpdated = (event) => {
    const minutesFromEvent = event?.detail?.autoTimerOffMinutes;
    const normalizedMinutes =
      minutesFromEvent !== undefined && minutesFromEvent !== null && minutesFromEvent !== ""
        ? Number(minutesFromEvent)
        : null;

    this.setState({
      autoTimerOffMinutes: Number.isNaN(normalizedMinutes) ? null : normalizedMinutes,
    }, () => {
      this.syncWindowsHelperState();
    });
  };

  registerAutoTimerSettingsListener = () => {
    window.addEventListener("auto-timer-off-settings-updated", this.handleAutoTimerSettingsUpdated);
  };

  removeAutoTimerSettingsListener = () => {
    window.removeEventListener("auto-timer-off-settings-updated", this.handleAutoTimerSettingsUpdated);
  };

  handleWindowsHelperAttentionSync = async () => {
    if (this.helperAttentionSyncInFlight) {
      return;
    }

    this.helperAttentionSyncInFlight = true;

    try {
      await this.syncWindowsHelperState();
      await this.syncWindowsHelperEvent();
      await this.checkServerTimerStopped();
    } finally {
      this.helperAttentionSyncInFlight = false;
    }
  };

  registerWindowsHelperAttentionListeners = () => {
    window.addEventListener("focus", this.handleWindowsHelperAttentionSync);
    window.addEventListener("pageshow", this.handleWindowsHelperAttentionSync);
    document.addEventListener("visibilitychange", this.handleWindowsHelperVisibilityChange);
  };

  removeWindowsHelperAttentionListeners = () => {
    window.removeEventListener("focus", this.handleWindowsHelperAttentionSync);
    window.removeEventListener("pageshow", this.handleWindowsHelperAttentionSync);
    document.removeEventListener("visibilitychange", this.handleWindowsHelperVisibilityChange);
  };

  handleWindowsHelperVisibilityChange = () => {
    if (document.visibilityState === "visible") {
      this.handleWindowsHelperAttentionSync();
    }
  };

  queueHelperPageRefresh = (delayMs = 0) => {
    if (this.helperAutoRefreshQueued) {
      return;
    }

    this.helperAutoRefreshQueued = true;
    window.setTimeout(() => {
      window.location.href = window.location.href;
    }, delayMs);
  };

  showAutoTimerOffToast = (message = "Your auto timer is off. Please clock in again.") => {
    toast.dismiss(AUTO_TIMER_OFF_TOAST_ID);
    toast.error(message, {
      toastId: AUTO_TIMER_OFF_TOAST_ID,
      autoClose: 2500,
      pauseOnFocusLoss: false,
    });
  };

  callWindowsHelper = async (path, options = {}) => {
    try {
      const response = await fetch(`${WINDOWS_HELPER_BASE_URL}${path}`, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...(options.headers || {}),
        },
      });

      if (!response.ok) {
        return null;
      }

      return await response.json();
    } catch (error) {
      return null;
    }
  };

  syncWindowsHelperState = async () => {
    const token = window.localStorage.getItem("authToken") || "";
    const userId = this.getCurrentUserKey();
    const payload = {
      token,
      userId,
      isTimerActive: !!this.state.isActive,
      autoTimerOffMinutes: Number(
        window.localStorage.getItem(AUTO_TIMER_OFF_MINUTES_KEY) || this.state.autoTimerOffMinutes || 0
      ),
      reason: window.localStorage.getItem(AUTO_TIMER_OFF_REASON_KEY) || this.state.autoTimerOffReason || "",
      apiUrl: config.apiurl,
    };

    const response = await this.callWindowsHelper("/state", {
      method: "POST",
      body: JSON.stringify(payload),
    });

    this.windowsHelperConnected = !!(response && response.connected);
    if (this.windowsHelperConnected) {
      this.clearAutoTimerOffReminder();
    }
    return this.windowsHelperConnected;
  };

  syncWindowsHelperEvent = async () => {
    const helperStatus = await this.callWindowsHelper("/status");
    this.windowsHelperConnected = !!(helperStatus && helperStatus.connected);

    if (!this.windowsHelperConnected) {
      return;
    }

    const eventResponse = await this.callWindowsHelper("/event");
    const eventPayload = eventResponse?.event;
    const currentUserId = this.getCurrentUserKey();

    if (
      !eventPayload ||
      !currentUserId ||
      eventPayload.userId !== currentUserId ||
      eventPayload.happenedAt === this.windowsHelperEventSeenAt
    ) {
      return;
    }

    this.windowsHelperEventSeenAt = eventPayload.happenedAt;
    this.lastAutoTimerOffNotificationAt = eventPayload.happenedAt;

    if (eventPayload.eventType === "reminder") {
      this.showAutoTimerOffToast(eventPayload.message);
      await this.callWindowsHelper("/event?ack=1");
      return;
    }

    this.setAttendanceTimerActiveFlag(false);
    workerTimers.clearInterval(this.countRef.current);
    workerTimers.clearInterval(this.totalCountRef.current);
    this.setState({ isActive: false, isLoading: false, stopTime: Date.now() });
    this.broadcastAutoTimerOffNotification(
      eventPayload.message || "Your auto timer is off. Please clock in again."
    );
    this.clearAutoTimerOffReminder();
    this.showAutoTimerOffToast(eventPayload.message);

    await this.callWindowsHelper("/event?ack=1");
    this.queueHelperPageRefresh(1500);
  };

  checkServerTimerStopped = async () => {
    if (!this.state.isActive || !this.props.user?.id) {
      return false;
    }

    try {
      const timeCount = await Authapi.durTime(this.props.user.id);
      const totalDurationInSec = parseInt(timeCount?.totalDurationInSec, 10);

      if (totalDurationInSec > 0) {
        return false;
      }

      this.setAttendanceTimerActiveFlag(false);
      this.queueHelperPageRefresh();

      return true;
    } catch (error) {
      return false;
    }
  };

  startWindowsHelperSync = () => {
    this.windowsHelperSyncInterval = workerTimers.setInterval(async () => {
      await this.syncWindowsHelperState();
      await this.syncWindowsHelperEvent();
      await this.checkServerTimerStopped();
    }, WINDOWS_HELPER_SYNC_INTERVAL_MS);
  };

  getCurrentUserKey = () => (this.props.user?.id ? String(this.props.user.id) : "");

  getAutoTimerOffReminderState = () => {
    const rawValue = window.localStorage.getItem(AUTO_TIMER_OFF_REMINDER_STATE_KEY);
    if (!rawValue) {
      return null;
    }

    try {
      return JSON.parse(rawValue);
    } catch (error) {
      console.error("Error parsing auto timer off reminder state:", error);
      return null;
    }
  };

  getAutoTimerOffReminderLastShown = () => {
    const rawValue = window.localStorage.getItem(AUTO_TIMER_OFF_REMINDER_LAST_SHOWN_KEY);
    if (!rawValue) {
      return null;
    }

    try {
      return JSON.parse(rawValue);
    } catch (error) {
      console.error("Error parsing auto timer off reminder last shown:", error);
      return null;
    }
  };

  markAutoTimerOffReminderShown = (shownAt = Date.now()) => {
    const currentUserKey = this.getCurrentUserKey();
    if (!currentUserKey) {
      return;
    }

    window.localStorage.setItem(
      AUTO_TIMER_OFF_REMINDER_LAST_SHOWN_KEY,
      JSON.stringify({
        userId: currentUserKey,
        shownAt,
      })
    );
  };

  isAutoTimerOffReminderActiveForCurrentUser = () => {
    const reminderState = this.getAutoTimerOffReminderState();
    const currentUserKey = this.getCurrentUserKey();

    return !!(
      reminderState &&
      currentUserKey &&
      reminderState.userId === currentUserKey &&
      reminderState.active
    );
  };

  stopAutoTimerOffReminderLoop = () => {
    if (this.autoTimerOffReminderInterval) {
      workerTimers.clearInterval(this.autoTimerOffReminderInterval);
      this.autoTimerOffReminderInterval = null;
    }
  };

  clearAutoTimerOffReminder = () => {
    this.stopAutoTimerOffReminderLoop();
    window.localStorage.removeItem(AUTO_TIMER_OFF_REMINDER_STATE_KEY);
    window.localStorage.removeItem(AUTO_TIMER_OFF_REMINDER_LAST_SHOWN_KEY);
  };

  triggerAutoTimerOffReminder = async () => {
    if (this.windowsHelperConnected) {
      this.clearAutoTimerOffReminder();
      return;
    }

    const reminderState = this.getAutoTimerOffReminderState();
    const currentUserKey = this.getCurrentUserKey();

    if (
      !reminderState ||
      !currentUserKey ||
      reminderState.userId !== currentUserKey ||
      !reminderState.active ||
      this.state.isActive
    ) {
      this.stopAutoTimerOffReminderLoop();
      return;
    }

    const lastShown = this.getAutoTimerOffReminderLastShown();
    const lastShownAt =
      lastShown && lastShown.userId === currentUserKey && lastShown.shownAt
        ? Number(lastShown.shownAt)
        : Number(reminderState.startedAt || 0);

    if (Date.now() - lastShownAt < AUTO_TIMER_OFF_REMINDER_INTERVAL_MS) {
      return;
    }

    const reminderMessage = reminderState.message || "Your auto timer is off. Please clock in again.";
    this.markAutoTimerOffReminderShown();
    this.showAutoTimerOffToast(reminderMessage);
    await this.showAutoTimerOffNotification(reminderMessage);
  };

  syncAutoTimerOffReminderLoop = () => {
    if (this.windowsHelperConnected || !this.isAutoTimerOffReminderActiveForCurrentUser() || this.state.isActive) {
      this.stopAutoTimerOffReminderLoop();
      return;
    }

    if (this.autoTimerOffReminderInterval) {
      return;
    }

    this.autoTimerOffReminderInterval = workerTimers.setInterval(() => {
      this.triggerAutoTimerOffReminder();
    }, 10000);
  };

  startAutoTimerOffReminder = (message = "Your auto timer is off. Please clock in again.") => {
    const currentUserKey = this.getCurrentUserKey();
    if (!currentUserKey) {
      return;
    }

    window.localStorage.setItem(
      AUTO_TIMER_OFF_REMINDER_STATE_KEY,
      JSON.stringify({
        userId: currentUserKey,
        active: true,
        message,
        startedAt: Date.now(),
      })
    );
    this.markAutoTimerOffReminderShown();
    this.syncAutoTimerOffReminderLoop();
  };

  requestNotificationPermission = async () => {
    if (!window.Notification) {
      return "unsupported";
    }

    if (window.Notification.permission === "granted") {
      return "granted";
    }

    if (window.Notification.permission === "default") {
      try {
        return await window.Notification.requestPermission();
      } catch (error) {
        console.error("Error requesting notification permission:", error);
      }
    }

    return window.Notification.permission;
  };

  ensureAutoTimerOffNotificationsEnabled = async () => {
    const permission = await this.requestNotificationPermission();

    if (permission === "denied") {
      toast.warn("Please allow browser notifications so auto timer off alerts can appear in the background.", {
        autoClose: 3500,
      });
    }

    return permission;
  };

  showDesktopNotification = async ({ title, body, path }) => {
    if (!body || !window.Notification) {
      return;
    }

    const permission = await this.requestNotificationPermission();
    if (permission !== "granted") {
      return;
    }

    const desktopNotification = new window.Notification(title || "Notification", {
      body,
      icon: "/logo.png",
      requireInteraction: true,
      tag: "auto-timer-off",
      renotify: true,
    });

    desktopNotification.onclick = () => {
      window.focus();
      if (path && this.props.history?.push) {
        this.props.history.push(path);
      }
    };
  };

  showAutoTimerOffNotification = async (message = "Your auto timer is off. Please clock in again.") => {
    if (this.windowsHelperConnected) {
      return;
    }

    await this.showDesktopNotification({
      title: "Auto Timer Off",
      body: message,
    });
  };

  broadcastAutoTimerOffNotification = (message = "Your auto timer is off. Please clock in again.") => {
    const currentUserId = this.props.user?.id ? String(this.props.user.id) : "";
    if (!currentUserId) {
      return;
    }

    const payload = {
      type: "auto_timer_off",
      userId: currentUserId,
      message,
      happenedAt: Date.now(),
    };

    this.lastAutoTimerOffNotificationAt = payload.happenedAt;
    window.localStorage.setItem(AUTO_TIMER_OFF_NOTIFICATION_KEY, JSON.stringify(payload));
  };

  handleAutoTimerOffNotificationEvent = async (event) => {
    try {
      if (event.key === AUTO_TIMER_OFF_REMINDER_STATE_KEY) {
        this.syncAutoTimerOffReminderLoop();
        return;
      }

      if (event.key !== AUTO_TIMER_OFF_NOTIFICATION_KEY || !event.newValue) {
        return;
      }

      const payload = JSON.parse(event.newValue);
      const currentUserId = this.getCurrentUserKey();

      if (
        !payload ||
        payload.type !== "auto_timer_off" ||
        !currentUserId ||
        payload.userId !== currentUserId ||
        payload.happenedAt === this.lastAutoTimerOffNotificationAt
      ) {
        return;
      }

      this.lastAutoTimerOffNotificationAt = payload.happenedAt;
      this.setAttendanceTimerActiveFlag(false);
      this.setState({ isActive: false });
      this.showAutoTimerOffToast(payload.message);
      if (this.windowsHelperConnected) {
        this.clearAutoTimerOffReminder();
      } else {
        this.startAutoTimerOffReminder(payload.message);
        await this.showAutoTimerOffNotification(payload.message);
      }
      this.queueHelperPageRefresh(1500);
    } catch (error) {
      console.error("Error handling auto timer off notification event:", error);
    }
  };

  registerAutoTimerNotificationListener = () => {
    window.addEventListener("storage", this.handleAutoTimerOffNotificationEvent);
  };

  removeAutoTimerNotificationListener = () => {
    window.removeEventListener("storage", this.handleAutoTimerOffNotificationEvent);
  };

  startAutoTimerWatcher = () => {
    this.autoTimerWatcherInterval = workerTimers.setInterval(() => {
      this.checkAutoTimerOff();
    }, AUTO_TIMER_OFF_WATCH_INTERVAL_MS);
  };

  shouldPreventAutoTimerOff = () => {
    const currentUserKey = this.props.user?.id ? String(this.props.user.id) : "";
    const storedReasonUserId = window.localStorage.getItem(AUTO_TIMER_OFF_REASON_USER_KEY);

    if (currentUserKey && storedReasonUserId && storedReasonUserId !== currentUserKey) {
      return false;
    }

    const currentReason =
      window.localStorage.getItem(AUTO_TIMER_OFF_REASON_KEY) || this.state.autoTimerOffReason;

    return AUTO_TIMER_OFF_EXEMPT_REASONS.includes(currentReason);
  };

  checkAutoTimerOff = async () => {
    const { isActive, isLoading, autoTimerOffMinutes } = this.state;
    const latestConfiguredMinutes =
      window.localStorage.getItem(AUTO_TIMER_OFF_MINUTES_KEY) || autoTimerOffMinutes;

    if (this.windowsHelperConnected) {
      return;
    }

    if (!isActive || isLoading || !latestConfiguredMinutes || this.shouldPreventAutoTimerOff()) {
      return;
    }

    if (document.visibilityState !== "visible" || !document.hasFocus()) {
      return;
    }

    const idleThresholdMs = Number(latestConfiguredMinutes) * 60 * 1000;
    if (!idleThresholdMs || Number.isNaN(idleThresholdMs)) {
      return;
    }

    const idleDuration = Date.now() - this.lastActivityAt;
    if (idleDuration < idleThresholdMs) {
      return;
    }

    this.lastActivityAt = Date.now();
    toast.info("No mouse or keyboard activity detected. Timer is auto stopping.");
    await this.proceedWithCheckout({
      toastMessage: "Timer auto stopped after inactivity",
      desktopNotificationBody: "Your auto timer is off. Please clock in again.",
    });
  };

  handleAutoTimerReasonChange = async (event) => {
    const reason = event.target.value;
    const currentUserKey = this.props.user?.id ? String(this.props.user.id) : "";

    if (currentUserKey) {
      window.localStorage.removeItem(AUTO_TIMER_OFF_LOGIN_RESET_KEY);
    }

    window.localStorage.setItem(AUTO_TIMER_OFF_REASON_KEY, reason);
    if (currentUserKey) {
      window.localStorage.setItem(AUTO_TIMER_OFF_REASON_USER_KEY, currentUserKey);
    }
    this.setState({ autoTimerOffReason: reason });
    this.updateLastActivity();

    const response = await Authapi.saveAutoTimerOffReason(reason);
    if (!response || !response.status) {
      toast.error("Failed to save auto timer off reason.");
      return;
    }

    const savedReason = response?.data?.user_reason || response?.data?.reason || "";
    window.localStorage.setItem(AUTO_TIMER_OFF_REASON_KEY, savedReason);
    if (currentUserKey) {
      window.localStorage.setItem(AUTO_TIMER_OFF_REASON_USER_KEY, currentUserKey);
    }
    this.setState({ autoTimerOffReason: savedReason }, () => {
      this.syncWindowsHelperState();
    });
  };

  breaktimeremainder = async () => {
    if (!this.state.isActive) {
      const result = await Authapi.breaktimeremainder();

      if (result.status === true) {
        if (Notification.permission === "default") {
          Notification.requestPermission().then(permission => {
            if (permission === "granted") {
              new Notification("Notification", {
                body: result.message,
                icon: "/logo.png",
              });
            }
          });
        } else if (Notification.permission === "granted") {
          new Notification("Notification", {
            body: result.message,
            icon: "/logo.png",
          });
        }
      }
    } else {

    }
  };



  runCycle() {
    this.countRef.current = workerTimers.setInterval(() => {
      this.setState((prevState) => ({ timer: prevState.timer + 1 }));
    }, 1000);
  }

  runCycle1() {
    if (this.state.isActive === true) {
      this.totalCountRef.current = workerTimers.setInterval(() => {
        this.setState((prevState) => ({ totaltimer: prevState.totaltimer + 1 }));
      }, 1000);
    }
  }

  handleStart = async () => {
    this.setState({ isLoading: true });
    await this.ensureAutoTimerOffNotificationsEnabled();
    await new Promise(resolve => setTimeout(resolve, 2000));

    try {
      await Authapi.inTime();
      this.lastActivityAt = Date.now();
      this.clearAutoTimerOffReminder();
      this.setState({ isActive: true, startTime: Date.now(), isLoading: false }, () => {
        this.setAttendanceTimerActiveFlag(true);
        this.runCycle();
        this.syncWindowsHelperState();
      });
      this.setState({ isActive: true, startTime: Date.now(), isLoading: false }, this.runCycle1);

      toast.success("You marked IN");

    } catch (error) {
      this.setState({ isLoading: false });
      const responseData = error.response?.data;
      const errorMessage = responseData?.message || "An error occurred while clocking in.";

      // Attempt to extract detailed information
      let pendingLeaves = responseData?.pending_leaves || [];
      let totalDays = responseData?.total_pending_days || responseData?.pending_count || (Array.isArray(pendingLeaves) ? pendingLeaves.length : 0);
      let fromDate = responseData?.from_date;
      let toDate = responseData?.to_date;

      // Handle cases where information might be in the errorMessage but not explicitly in data fields
      if (!totalDays || !fromDate) {
        // Simple regex to find dates in DD-MM-YYYY or YYYY-MM-DD format
        const dateRegex = /(\d{2}-\d{2}-\d{4})|(\d{4}-\d{2}-\d{2})/g;
        const foundDates = errorMessage.match(dateRegex);
        if (foundDates) {
          if (!fromDate) fromDate = foundDates[0];
          if (!toDate) toDate = foundDates[foundDates.length - 1];
          if (!totalDays) totalDays = foundDates.length;
        }
      }

      // If we have an array of leaves, ensure from/to dates are set
      if (Array.isArray(pendingLeaves) && pendingLeaves.length > 0) {
        const first = pendingLeaves[0];
        const last = pendingLeaves[pendingLeaves.length - 1];
        if (!fromDate) fromDate = typeof first === 'string' ? first : first.date;
        if (!toDate) toDate = typeof last === 'string' ? last : last.date;
      }

      const showAddLeaveButton = errorMessage !== "You have already \"Clocked In\" today!! Please refresh the page.";
      const isPendingLeaveError = errorMessage.toLowerCase().includes("pending") || errorMessage.toLowerCase().includes("leave") || totalDays > 0;

      if (isPendingLeaveError && showAddLeaveButton) {
        // Fetch actual absent dates if they're missing from the error response
        if (!fromDate) {
          try {
            const today = new Date();
            let month = today.getMonth() + 1;
            let year = today.getFullYear();
            
            let attendanceRes = await Authapi.getAttendance(this.props.user.id, month, year);
            let absentDays = [];

            if (attendanceRes && attendanceRes.status && Array.isArray(attendanceRes.data)) {
              absentDays = attendanceRes.data.filter(day => day.status.toLowerCase() === 'absent');
            }

            // If no absent days this month, check last month too
            if (absentDays.length === 0) {
              month = month === 1 ? 12 : month - 1;
              year = month === 12 ? year - 1 : year;
              attendanceRes = await Authapi.getAttendance(this.props.user.id, month, year);
              if (attendanceRes && attendanceRes.status && Array.isArray(attendanceRes.data)) {
                absentDays = attendanceRes.data.filter(day => day.status.toLowerCase() === 'absent');
              }
            }

            if (absentDays.length > 0) {
              // Sort by date to get correct range
              absentDays.sort((a, b) => {
                const [da, ma, ya] = a.date.split('-').map(Number);
                const [db, mb, yb] = b.date.split('-').map(Number);
                return new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db);
              });

              fromDate = absentDays[0].date;
              toDate = absentDays[absentDays.length - 1].date;
              totalDays = absentDays.length;
            }
          } catch (fetchError) {
            console.error("Error fetching attendance for popup:", fetchError);
          }
        }

        const content = document.createElement("div");
        content.className = "pending-leave-container";
        content.innerHTML = `
          <p class="pending-leave-message">Add Your Pending Leave.</p>
          <div class="pending-leave-card">
            <table class="pending-leave-table">
              <tr>
                <td class="pending-leave-label">Total Day(s):</td>
                <td class="pending-leave-value">${totalDays || '1'} Day</td>
              </tr>
              <tr>
                <td class="pending-leave-label">From Date:</td>
                <td class="pending-leave-value">${fromDate || 'N/A'}</td>
              </tr>
              <tr>
                <td class="pending-leave-label">To Date:</td>
                <td class="pending-leave-value">${toDate || fromDate || 'N/A'}</td>
              </tr>
            </table>
          </div>
          <p class="pending-leave-footer">Please submit a leave request for the above period to start timer!</p>
        `;

        swal({
          title: "Remaining Leave Alert",
          content: content,
          className: "pending-leave-modal",
          buttons: {
            cancel: {
              text: "Cancel",
              value: null,
              visible: true,
              className: "swal-cancel-btn",
              closeModal: true
            },
            add: {
              text: "Add Leave",
              value: "add",
              visible: true,
              className: "swal-add-leave-btn",
              closeModal: true
            }
          }
        }).then((value) => {
          if (value === "add") {
            this.props.history.push({
              pathname: "/leave-tickets/add",
              state: {
                date: fromDate,
                endDate: toDate,
                type: "Loss Of Pay",
                message: "Pending Leave"
              }
            });
          } else {
            window.location.reload();
          }
        });
      } else {
        swal({
          title: "Error",
          text: errorMessage,
          icon: "error",
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "gray-button",
              closeModal: true
            },
            ...(showAddLeaveButton && {
              add: {
                text: "Add Leave",
                value: "add",
                visible: true,
                className: "swal-add-leave-btn",
                closeModal: true
              }
            })
          }
        }).then((value) => {
          if (value === "add") {
            this.props.history.push({
              pathname: "/leave-tickets/add",
              state: {
                type: "Loss Of Pay",
                message: "Pending Leave"
              }
            });
          } else {
            window.location.reload();
          }
        });
      }
    }
  };

  handlePause = async () => {
    this.setState({ isLoading: true });
    try {

      const monthlyData = await Authapi.getMonthlyWorkHours(this.props.user.id);

      if (
        monthlyData &&
        monthlyData.hasOwnProperty('workingHoursAlertEnabled') &&
        monthlyData.workingHoursAlertEnabled === false
      ) {
        await this.proceedWithCheckout();
        return;
      }

      if (monthlyData && monthlyData.status) {
        const totalDurationToday = monthlyData.totalDurationToday || 0;


        let isInDynamicWindow = false;
        if (Object.prototype.hasOwnProperty.call(monthlyData, 'isCurrentSessionSevenToEight')) {
          isInDynamicWindow = !!monthlyData.isCurrentSessionSevenToEight;
        } else if (
          monthlyData &&
          (monthlyData.targetFullDayHours !== undefined && monthlyData.targetUpperHours !== undefined) &&
          typeof totalDurationToday === 'number'
        ) {
          const lower = Number(monthlyData.targetFullDayHours) * 3600;
          const upper = Number(monthlyData.targetUpperHours) * 3600;
          isInDynamicWindow = totalDurationToday >= lower && totalDurationToday < upper;
        } else {
          isInDynamicWindow = totalDurationToday >= 25200 && totalDurationToday < 28800;
        }

        if (isInDynamicWindow) {
          this.setState({ isLoading: false });

          const result = await swal({
            title: "Working hours alert!",
            text: `You are within your working hours alert window. Would you like to proceed with checkout?`,
            icon: "warning",
            buttons: {
              stayIn: { text: "STAY IN", value: "stayIn", className: "swal-stay-in-btn" },
              stayOut: { text: "STAY OUT", value: "stayOut", className: "swal-stay-out-btn" }
            },
            dangerMode: true
          });
          if (result === "stayIn") return;
          else if (result === "stayOut") await this.proceedWithCheckout();
        } else {
          await this.proceedWithCheckout();
        }
      } else {

        await this.proceedWithCheckout();
      }
    } catch (error) {

      await this.proceedWithCheckout();
    }
  };

  proceedWithCheckout = async (options = {}) => {
    const {
      toastMessage = "You marked OUT",
      desktopNotificationBody = "",
    } = options;

    await new Promise(resolve => setTimeout(resolve, 2000));

    try {
      const response = await Authapi.outTime();
      if (response === false) {
        throw new Error("Failed to clock out.");
      }

      if (desktopNotificationBody) {
        await this.showAutoTimerOffNotification(desktopNotificationBody);
        this.startAutoTimerOffReminder(desktopNotificationBody);
        this.broadcastAutoTimerOffNotification(desktopNotificationBody);
      }

      this.setState({ isActive: false, stopTime: Date.now(), isLoading: false }, () => {
        workerTimers.clearInterval(this.countRef.current);
        workerTimers.clearInterval(this.totalCountRef.current);
        this.setAttendanceTimerActiveFlag(false);
        this.syncWindowsHelperState();

        toast.error(toastMessage, { autoClose: 1500 });
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
    } catch (error) {
      this.setState({ isLoading: false });
      console.error("Error during checkout:", error);
    }
  };

  formatTime = () => {
    const { timer } = this.state;
    const getSeconds = `0${timer % 60}`.slice(-2);
    const minutes = Math.floor(timer / 60);
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);
    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  formatTime1 = () => {
    const { totaltimer } = this.state;
    const getSeconds = `0${totaltimer % 60}`.slice(-2);
    const minutes = Math.floor(totaltimer / 60);
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(totaltimer / 3600)}`.slice(-2);

    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  render() {
    if (this.state.isInitialLoading) {
      return <div className="stopwatch-card"><p className="timerText" style={{ marginLeft: "40px" }}>Loading...</p></div>;
    }

    return (


      <div className="stopwatch-card">
        <p className="timerText">{this.formatTime1()}</p>
        <div className="buttons">
          {!this.state.isActive && (
            <PremiumButton
              onClickFn={this.handleStart}
              btnText="IN"
              loading={this.state.isLoading}
              disabled={this.state.isLoading}
            />
          )}
          {this.state.isActive && (
            <PremiumButton
              onClickFn={this.handlePause}
              btnText="OUT"
              loading={this.state.isLoading}
              disabled={this.state.isLoading}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Timer);










